/**
 * The popup box used by the Search Results map widget
 *
 * This directly extends from the InfoBox library in the CDN
 * @param {Object} options Any custom options to add to the info box
 */
function SearchMapInfoBoxMulti(options) {
    InfoBox.call(this, $.extend({
        disableAutoPan: false,
        maxWidth: 0,
        pixelOffset: new google.maps.Size(-129, -33),
        zIndex: null,
        boxClass: "info-box multi-pin",
        closeBoxMargin: "6px",
        closeBoxURL: "/images/close.gif",
        infoBoxClearance: new google.maps.Size(5, 46),
        isHidden: false,
        pane: "floatPane",
        alignBottom: true,
        enableEventPropagation: false
    }, options));
}

if(typeof InfoBox === undefined) {
    console.error("InfoBox library was not found");
}
//Extend the Google Maps marker
SearchMapInfoBoxMulti.prototype = Object.create(InfoBox.prototype);
SearchMapInfoBoxMulti.prototype.constructor = InfoBox;
SearchMapInfoBoxMulti.prototype.renderListings = function(listings, length) {
    var sliderCount = 1;
    var transition = false;
    if(listings.length > 0) {
        var slider = '<div class="flexslider flexslider-units"><div class="rental-count">&nbsp; &nbsp; <span id="slider-count">' + sliderCount + '</span> of ' + listings.length + ' Rentals Here</div><ul class="slides">';

        for (var i = 0, l = listings.length; i < l; i++) {
            var content = $(".listing[data-unitid=" + listings[i].unitID + "] .mod-listing").data('initSlide');
            slider += "<li class='slide-counter'>" + content + "</li>";
        }

        slider += '</ul></div><div class="custom-navigation"><a href="#" class="flex-prev"></a><div class="custom-controls-container"></div><a href="#" class="flex-next"></a></div>';
        this.close();
        this.open(this.map, this);
        this.setContent(slider);
        // multi unit flexslider carousel
        google.maps.event.addListenerOnce(this,'domready',function(){
            var unitFlexslider =  $('.flexslider-units .slides');
            unitFlexslider.flexslider({
                selector: ".slide-counter",
                controlNav: false,
                slideshow: false,
                animationSpeed: 200,
                touch: false,
                keyboard: false,
                controlsContainer: $(".custom-controls-container"),
                customDirectionNav: $(".custom-navigation a"),

                before: function(unitFlexslider) {
                    var index = unitFlexslider.animatingTo + 1;
                    $('#slider-count').html(unitFlexslider.animatingTo+1);
                },
                start: function(){
                    unitFlexslider.resize();
                    unitFlexslider.find(".flexslider-listing").removeClass("flexslider-listing").addClass("flexslider-multi");

                    $(".flexslider-multi .slides").children('li').addClass('slide');

                    $('.flexslider-multi').flexslider({
                        selector: ".slides > .slide",
                        controlNav: false,
                        slideshow: false,
                        animationSpeed: 200,

                        // lazy load carousel images
                        start: function(slider){ // Fires when the slider loads the first slide
                            var slide_count = slider.count - 2;

                            $(slider).find('img.lazy:eq(0), img.lazy:eq(' + slide_count + ')').each(function() {
                                var src = $(this).attr('data-src');
                                $(this).attr('src', src).removeAttr('data-src');
                            });
                        },
                        before: function(slider) { // Fires asynchronously with each slider animation
                            var slides     = slider.slides,
                                next       = slider.animatingTo,
                                $slide     = $(slides[next]),
                                $img       = $slide.find('img[data-src]'),
                                nxt_slide  = next,
                                prev_slide = next - 2;

                            $slide.parent().find('img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')').each(function() {
                                    var src = $(this).attr('data-src');
                                    $(this).removeAttr('data-src').attr('src', src);
                                    $(this).parent().addClass('flex-slide');
                                });
                        }
                    });
                }
            });
        });
    }
};
window.SearchMapInfoBoxMulti = SearchMapInfoBoxMulti;



//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/SearchMapInfoBoxMulti.js
// module id = 9
// module chunks = 0